module.exports = __webpack_public_path__ + "img/xingjiabi1.57605829.jpg";